import { Vorgang } from "../types/remote/Vorgang";

export function generateVorgang(): Vorgang {
  return { Text: "", VID: -1, aenderung: "", vorgangstyp: "SONSTIGE" };
}
